import { Box, Text } from '@factorialco/deprecated-design-system'
import { PayrollIncidenceChangesDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import IncidenceDetailDataChangeLine from 'modules/bookkeepers/components/IncidenceDetailDataChangeLine'

interface Params {
  incidenceId: string
}

const GenericIncidenceInfo = ({ incidenceId }: Params) => {
  const { data: incidenceChangesData } = useQuery(PayrollIncidenceChangesDocument, {
    variables: {
      incidenceId: incidenceId,
    },
  })
  const incidenceChanges =
    incidenceChangesData?.bookkeepersManagement.incidenceChangesConnection.nodes || []

  return incidenceChanges.map((changeGroup) => (
    <Box gap="s8" paddingBottom="s24" key={`${changeGroup.category}-category-changes`}>
      <Text.Normal size="200" color="grey800" weight="bold">
        {changeGroup.category}
      </Text.Normal>
      <Box gap="s2" component="ul" paddingLeft="s16" style={{ listStyle: 'disc' }}>
        {changeGroup.changes.map((change) => (
          <IncidenceDetailDataChangeLine
            key={`${change.field}-field-diff`}
            label={change.label}
            oldValue={change.oldValue ?? null}
            newValue={change.newValue ?? null}
          />
        ))}
      </Box>
    </Box>
  ))
}

export default GenericIncidenceInfo
